/* eslint-disable */
import axios from "axios";
import { AppUrl } from "@/assets/js/variables";

const state = {
  clients: [],
  domains: [],
};

const getters = {
    // get clients () {
    //     return this.clients;
    // } <--wrong
};

const mutations = {
    SET_CLIENTS(state, data){
        console.log('set_clients', data)
        state.clients = data;
        console.log('clients', state.clients)
    },

    SET_DOMAINS(payload){
        this.domains = payload;
        console.log('domains', this.domains)
    }
};

const actions = {
    GET_CLIENTS({ state, commit }) {
        return new Promise((resolve, reject) => {
          axios
            .post(AppUrl, {
              task: "load_clients",
            })
            .then(function (response) {
                commit("SET_CLIENTS",response.data.clients)
                resolve(response);
            })
            .catch((err) => reject(err));
        });
      },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/global.js